import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { renderDesktopNav, renderMobileNav } from './layout/index.js';
import '../../../../node_modules/lit-media-query/lit-media-query.js';
import css_248z from './styles/pim-subnav.scss.js';
import { updateCategories } from './utils/index.js';

class PimSubnav extends s {
    constructor() {
        super(...arguments);
        this.categories = null;
        this.data = null;
        this.isHidden = true;
        this.query = '(max-width: 959px)';
        this.isMobile = false;
    }
    handleMediaQuery(e) {
        this.isMobile = e.detail.value;
        this.requestUpdate();
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.data)
            updateCategories(this.data, this);
    }
    render() {
        return $ `${!this.isMobile
            ? renderDesktopNav(this)
            : renderMobileNav(this)}<lit-media-query .query="${this.query}" @changed="${this.handleMediaQuery}"></lit-media-query>`;
    }
}
PimSubnav.styles = css_248z;
__decorate([
    e()
], PimSubnav.prototype, "data", void 0);
__decorate([
    e({ type: String })
], PimSubnav.prototype, "mobileMenuTitle", void 0);
__decorate([
    t()
], PimSubnav.prototype, "isHidden", void 0);
__decorate([
    t()
], PimSubnav.prototype, "query", void 0);
__decorate([
    t()
], PimSubnav.prototype, "isMobile", void 0);
customElements.define('pim-subnav', PimSubnav);

export { PimSubnav };
